import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition,
} from "app/library/layout-builder";
import { SettlementPlanProps } from "./types";

export class SettlementPlanDefinitions extends CmsReactComponent<SettlementPlanProps> {
    static defaultProps = {};

    static schemaName = "settlement-plan";

    static propertyDefinitions: PropertyDefinition[] = [];
}
